export enum EquipmentColumnKeys {
  IMAGE = 'equipmentImage',
  NAME = 'equipmentName',
  CUSTOMER_NAME = 'customerName',
  CUSTOMER_SERIAL_NUMBER = 'equipmentCustomerSerialNumber',
  SERIAL_NUMBER = 'equipmentSerialNumber',
  LABELS = 'equipmentLabels',
  MODEL = 'equipmentModel',
  TYPE_CATEGORY1 = 'equipmentType.category1',
  TYPE_CATEGORY2 = 'equipmentType.category2',
  MANUFACTURER_NAME = 'manufacturerName',
  CURRENT_ADDRESS = 'address',
  STATUS = 'status',
  BEUTLHAUSER_ID = 'equipmentBeutlhauserId',
  COST_CENTER = 'equipmentCostCenter',
  CONSTRUCTION_YEAR = 'equipmentConstructionYear',
  CURRENT_LOCATION_NAME = 'currentLocationName',
  CURRENT_LOCATION_NUMBER = 'currentLocationNumber',
  CURRENT_LOCATION_COST_CENTER = 'currentLocationCostCenter',
  CURRENT_OPERATING_HOURS = 'currentOperatingHours',
  OPERATING_HOURS_LAST_UPDATED = 'operatingHoursLastUpdated',
  CURRENT_MILEAGE = 'currentMileage',
  MILEAGE_LAST_UPDATED = 'mileageLastUpdated',
  ORGANISATION = 'organisationName',
  SCAN_CODE = 'equipmentScanCode',
  BGL_CODE = 'equipmentBGLCode',
  LICENSE_PLATE = 'equipmentLicensePlate',
  REGISTRATION_DATE = 'equipmentRegistrationDate',
  ASSIGNED_OWNER = 'assignedOwner',
  ASSIGNED_PERSON_IN_CHARGE = 'assignedPersonInCharge',
  ASSIGNED_MAINTENANCE_ASSIGNEE = 'assignedMaintenanceAssignee',
  ASSIGNED_DRIVER = 'assignedDriver',
  ASSIGNED_POSSESSOR = 'assignedPossessor',
  DETAILS = 'openDetails',
  ATTENTION_STATUS = 'attentionStatus',
  CORE_DATA = 'coreData',
  EQUIPMENT_FAVOURITE = 'equipmentFavourite',
  EQUIPMENT_NONE = 'equipmentNone',
  EQUIPMENT_TELEMATICS_UNIT = 'equipmentTelematicsUnit',
  LAST_TELEMATICS_UPDATE = 'lastTelematicsUpdate',
  ASSIGNED_TELEMATICS_UNIT = 'assignedTelematicsUnit',
  TELEMATICS_UNIT_TYPE = 'telematicsUnitType',
  CURRENT_ACTIVITY_STATUS = 'currentActivityStatus',
}
